import * as tslib_1 from "tslib";
import { FormArray, FormGroup } from '@angular/forms';
import { hasProps } from '../helpers/object';
export function makeValidatorFn(validator, extension) {
    return function (control) {
        var value = control.value;
        var result = validator(value);
        if (extension)
            result = tslib_1.__assign({}, result, extension(value));
        if (hasProps(result))
            return result;
        return null;
    };
}
function humanizeControls(controls, translations) {
    return controls.reduce(function (result, combined) {
        var _a;
        combined.control.markAsTouched();
        if (!hasProps(combined.control.errors))
            return result;
        var errors = Object.keys(combined.control.errors);
        return tslib_1.__assign({}, result, (_a = {}, _a[combined.name] = errors.map(function (err) { return ({
            translationCode: translations[err],
            params: tslib_1.__assign({}, combined.control.errors[err].params, { field: combined.translatedName })
        }); }), _a));
    }, {});
}
export function humanizeValidationErrors(control, translations, fieldMap) {
    if (control instanceof FormGroup) {
        var group_1 = control;
        var controls = Object.keys(group_1.controls);
        return humanizeControls(controls.map(function (name) { return ({ name: name, translatedName: fieldMap[name], control: group_1.controls[name] }); }), translations);
    }
    if (control instanceof FormArray) {
        var array = control;
        return humanizeControls(array.controls.map(function (control, name) { return ({ name: name, translatedName: '', control: control }); }), translations);
    }
    return humanizeControls([{ name: 'control', translatedName: '', control: control }], translations);
}
